import LandingHeader from './Header/LandingHeader'

export default LandingHeader as typeof LandingHeader